module.exports = __webpack_public_path__ + "media/base/x-blue-733cca5a.svg";